
export default {
	name: 'Server.ServiceTypes',
	options: {
		schema: 'server',
		table: 'service_type',
		limit: 10000,
		fields: ['type_name']
	}
};

